import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useAssets } from "../assets/AssetsContext";
import ClientLogoSlider from "./ClientLogoSlider";
import TabImage from "./TabImage";
import { Link } from "react-router-dom";
import PodcastPlayer from "./PodcastPlayer";

// const podcastData = [
//   {
//     id: 1,
//     title: "Drought Climate Change Biochar",
//     src: "/audio/audio1.mp3",
//     duration: 3603,
//   },
//   {
//     id: 2,
//     title: "CC Food security and Biochar",
//     src: "/audio/audio2.mp3",
//     duration: 7211,
//   },
//   {
//     id: 3,
//     title: "Drought and Biochar",
//     src: "/audio/audio3.mp3",
//     duration: 3600,
//   },
// ];

function Bioforge() {
  const assets = useAssets();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
    AOS.refresh();
  }, []);

  const [currentlyPlayingId, setCurrentlyPlayingId] = useState(null);

  // const handlePlay = (id) => {
  //   if (id === currentlyPlayingId) {
  //     setCurrentlyPlayingId(null); // Pause if clicked again
  //   } else {
  //     setCurrentlyPlayingId(id); // Play new one
  //   }
  // };
  return (
    <div>
      <div className="inner-new-section-1 bioforge-bg-1">
        <div className="wrapper height-inherit">
          <div className="bottom-sec-1 max-width-500 padding-bottom-2">
            <h1 className="white-color" data-aos="fade-up">
              BioFORGE<sup>™</sup> – Modular Biochar Units for a Carbon-Negative
              Future
            </h1>
            <p data-aos="zoom-in">
              Unlock climate-smart solutions with plug-and-play biochar systems
              for carbon removal, soil health, and sustainable infrastructure.
            </p>
            <div className="text-left" data-aos="fade-down">
              <Link
                to="/company/contact#Book-Meeting"
                className="button-1 green-bg"
              >
                Request a Demo
              </Link>
              <Link to="/company/contact#Book-Meeting" className="button-1">
                Partner With Us
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-new-section-1 bioforge-bg-2">
        <div className="wrapper height-inherit">
          <div className="top-sec-1 text-right">
            <div className="our-vision-wrap float-right-1"></div>
          </div>

          <div className="bottom-sec-1 padding-bottom-2">
            <h2 className="white-color" data-aos="fade-down">
              A Biochar Revolution at the Core of Climate Action
            </h2>
            <p data-aos="fade-up">
              “Our vision is simple: turn agricultural and organic waste into a
              multi-benefit climate tool that supports both people and the
              planet.”
            </p>
            <p data-aos="fade-up">
              BioFORGE™ is a decentralized, modular pyrolysis system that
              transforms biomass waste into high-grade biochar. Designed for
              flexibility, portability, and measurable impact, BioFORGE™ enables
              climate mitigation, regenerative agriculture, water purification,
              and clean construction—all from a single compact unit.
            </p>
          </div>
        </div>
      </div>

      <div className="ecosystem-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 data-aos="fade-up">Biochar Manufacturing, Made Smarter</h2>
            <p data-aos="fade-down">
              Each BioFORGE™ unit is a complete biochar manufacturing
              solution—combining high-efficiency pyrolysis, emissions control,=
              and process automation to produce clean, carbon-rich biochar.
            </p>
          </div>
          <div className="smarter-sec-wrap">
            <div className="text-left">
              <div className="smarter-sec-1 core-features" data-aos="fade-down">
                <h4>Core Features:</h4>
                <ul>
                  <li>Thermochemical pyrolysis at 400–600°C</li>
                  <li>
                    Real-time temperature, pressure, and feedstock monitoring
                  </li>
                  <li>Auto-feed and batch-feed options</li>
                  <li>
                    Adaptive airflow and oxygen control to optimize carbon yield
                  </li>
                </ul>
                <p>
                  <b>Outputs: Biochar, syngas, and (optional) bio-oil</b>
                </p>
              </div>
            </div>
            <div className="text-right">
              <div
                className="smarter-sec-1 feedstock-supported"
                data-aos="fade-up"
              >
                <div className="circle-1">
                  <img src={assets.Smartercircle} alt="" />
                </div>
                <h4>Feedstock Supported:</h4>
                <ul>
                  <li>
                    Crop waste (paddy husk, cotton stalks, sugarcane bagasse)
                  </li>
                  <li>Invasive species (Prosopis juliflora, Lantana)</li>
                  <li>Forestry residue and green municipal waste</li>
                  <li>
                    Coconut shells, sawdust, coffee husk, press mud, and more
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flagship-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2>Integrated Impact Across 6 Global Challenges</h2>
            <p>
              From drylands to data platforms, our breakthrough initiatives
              showcase how scalable climate engineering is driving real-world
              transformation.
            </p>
          </div>

          <div className="timeline">
            <div className="timeline-line"></div>

            <div className="timeline-item right">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img
                  src={assets.bioforgeimg1}
                  alt=""
                  data-aos="zoom-out-down"
                />
                <h3>Climate Change Mitigation & Adaptation</h3>
                <p>
                  <ul>
                    <li>
                      Carbon-negative infrastructure in rural & urban areas
                    </li>
                    <li>
                      Nature-based sequestration through long-life biochar
                    </li>
                    <li>
                      Soil and microclimate restoration in degraded regions
                    </li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="timeline-item left">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img src={assets.bioforgeimg2} alt="" data-aos="zoom-out-up" />
                <h3>End-to-End Carbon Credit Solutions</h3>
                <p>
                  <ul>
                    <li>
                      MRV-aligned pyrolysis tech ready for Verra, Puro.earth
                    </li>
                    <li>
                      Blockchain-ready traceability from input to application
                    </li>
                    <li>Registration & credit issuance support for VCMs</li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img
                  src={assets.bioforgeimg3}
                  alt=""
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="3000"
                />
                <h3>Biochar for Agriculture & Soil Health</h3>
                <p>
                  <ul>
                    <li>
                      Custom blends for soil fertility & nutrient retention
                    </li>
                    <li>
                      Compatible with organic & regenerative farming practices
                    </li>
                    <li>Fungal biochar to restore microbial ecosystems</li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="timeline-item left">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img src={assets.bioforgeimg4} alt="" data-aos="zoom-out-up" />
                <h3>Water Quality, Sanitation & Ecosystem Restoration</h3>
                <p>
                  <ul>
                    <li>Biochar filters for drinking & irrigation water</li>
                    <li>
                      Lake/wetland remediation with nutrient-locking composites
                    </li>
                    <li>Greywater treatment for sanitation and reuse</li>
                  </ul>
                </p>
              </div>
            </div>

            <div className="timeline-item right">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img
                  src={assets.bioforgeimg5}
                  alt=""
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="3000"
                />

                <h3>Geoengineering & Construction Innovations</h3>
                <p>
                  <ul>
                    <li>Biochar-concrete and biochar-mortar composites</li>
                    <li>Passive insulation, lightweight bricks & plasters</li>
                    <li>Low-carbon housing and eco-infrastructure</li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="timeline-item left">
              <div className="timeline-icon"></div>
              <div className="timeline-content">
                <img src={assets.bioforgeimg6} alt="" data-aos="zoom-out-up" />

                <h3>Environment & Health Integration</h3>
                <p>
                  <ul>
                    <li>Air purification and odor control in waste zones</li>
                    <li>
                      Vector barrier and mosquito suppression in urban
                      sanitation
                    </li>
                    <li>Climate and health co-benefits in smart city plans</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 bioforge-bg-3">
        <div className="wrapper height-inherit">
          <div className="bioforge-align-right ">
            <div className="bioforge-section-2-1">
              <h2 className="green-color">What Makes BioFORGE™ Unique?</h2>
              <div className="building-list black-color">
                <ul>
                  <li>Modular & mobile with trailer-mounted deployment</li>
                  <li>IoT-enabled controls with cloud-based analytics</li>
                  <li>Biochar yield optimization with smart burn curves</li>
                  <li>Carbon content: 60–90% fixed carbon </li>
                  <li>Designed for low-maintenance and field operability</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 bioforge-bg-4">
        <div className="wrapper height-inherit">
          <div className="flagship-heading">
            <h2>Deployment Models</h2>
          </div>
          <img
            src={assets.DeploymentModels}
            alt="DeploymentModels"
            data-aos="zoom-out-up"
          />

          <div className="bioforge-2-2">
            <div className="bioforge-2-2-1" data-aos="zoom-in-down">
              <img src={assets.DeploymentModels1} alt="" />
              <span>Lease-to-own for FPOs & co-operatives</span>
            </div>

            <div className="bioforge-2-2-1" data-aos="zoom-in-down">
              <img src={assets.DeploymentModels2} alt="" />
              <span>Government-led sustainability programs</span>
            </div>
            <div className="bioforge-2-2-1" data-aos="zoom-in-down">
              <img src={assets.DeploymentModels3} alt="" />
              <span>Carbon-removal-as-a-service (CRaaS) models</span>
            </div>
            <div className="bioforge-2-2-1" data-aos="zoom-in-down">
              <img src={assets.DeploymentModels4} alt="" />
              <span>Municipal PPPs for urban biochar grids</span>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 bioforge-bg-5">
        <div className="wrapper height-inherit">
          <div className="text-center">
            <h2>Impact Metrics That Matter</h2>
          </div>
          <TabImage />
        </div>
      </div>

      <div className="flagship-bg height-inherit-1">
        <div className="wrapper ">
          <div className="flagship-heading">
            <h2>Carbon Credit Ready, MRV Compliant</h2>
          </div>
          <div className="carbon-wrap">
            <div className="carbon-1" data-aos="fade-up">
              <img src={assets.Verra} alt="Fromwaste" />
              <span>Pre-integrated with</span>
              <p>Verra VM0044, Gold Standard, Puro.earth</p>
            </div>
            <div className="carbon-1" data-aos="zoom-in">
              <img src={assets.Sylvera} alt="Fromwaste" />
              <span>Compatible with dMRV tools:</span>
              <p>Sylvera, NCX, CarbonFuture</p>
            </div>
            <div className="carbon-1" data-aos="fade-down">
              <img src={assets.Fromwaste} alt="Fromwaste" />
              <span>Traceable biochar life-cycle:</span>
              <p>From waste to soil</p>
            </div>
          </div>
        </div>
      </div>

      <div className="inner-new-section-1 bioforge-bg-7">
        <div className="wrapper ">
          <div className="flagship-heading">
            <h2 className="green-color">Insights from an Industry Pioneer</h2>
            <p>
              Dr. Sai Bhaskar Reddy Nakka, a globally recognized expert in
              biochar and low-cost climate technologies, has contributed
              immensely to the field through his research, grassroots work, and
              thought leadership.
            </p>
            <div className="Industry-Pioneer">
              <div className="Industry-Pioneer-1">
                <img
                  src={assets.SaiBhaskarReddy}
                  alt="Sai Bhaskar Reddy"
                  data-aos="zoom-in"
                />
              </div>
              <div className="Industry-Pioneer-2">
                <i>
                  "Biochar is not just a material; it is a catalyst for soil
                  regeneration, water security, and climate resilience."
                </i>
                <p>— Dr. Sai Bhaskar Reddy</p>
              </div>
            </div>
          </div>
          <div className="Feature-work ">
            <div className="Feature-work-1">
              <h4>Why Feature His Work?</h4>
              <p>
                His insights complement the BioFORGE™ mission of scalable,
                regenerative, and inclusive climate technology—bringing
                scientific validation and field experience into one narrative.
              </p>
            </div>
            <div className="Feature-work-2">
              <div className="Feature-work-2-1">
                <a href={assets.Biocharculture} target="_blank">
                  <img
                    src={assets.Featurework_1}
                    alt="Featurework"
                    data-aos="zoom-in"
                  />
                </a>
              </div>
              <div className="Feature-work-2-1">
                <a href={assets.BiocharSpecificationTesting} target="_blank">
                  <img
                    src={assets.Featurework_2}
                    alt="Featurework"
                    data-aos="zoom-in"
                  />
                </a>
              </div>
              {/* <img
                src={assets.Featurework}
                alt="Featurework"
                data-aos="zoom-in"
              /> */}
            </div>
          </div>
          <div className="Podcasts-bg">
            <div className="Podcasts-list">
              <h2 className="white-color text-left">Podcasts</h2>
              <PodcastPlayer
                title="Drought Climate Change Biochar"
                src="/audio/audio1.mp3"
                duration={60 * 60 + 3} // 60:03
              />
              <PodcastPlayer
                title="CC Food security and Biochar"
                src="/audio/audio2.mp3"
                duration={120 * 60 + 11} // 120:11
              />
              <PodcastPlayer
                title="Drought and Biochar"
                src="/audio/audio3.mp3"
                duration={60 * 60} // 60:00
              />

              {/* {podcastData.map((podcast) => (
                <PodcastPlayer
                  key={podcast.id}
                  id={podcast.id}
                  title={podcast.title}
                  src={podcast.src}
                  duration={podcast.duration}
                  isPlaying={currentlyPlayingId === podcast.id}
                  onPlay={handlePlay}
                />
              ))} */}
            </div>
          </div>
        </div>
      </div>

      <div className="ClimateFutureTogether-bg">
        <div className="wrapper">
          <div className="flagship-heading">
            <h2 className="green-color">
              Let’s Forge the Carbon-Negative Future Together
            </h2>
            <p>
              Deploy BioFORGE™ to transform waste into wealth and climate risk
              into opportunity.
            </p>

            <Link
              to="/company/contact#Book-Meeting"
              className="button-1 green-bg"
            >
              Book a Consultation
            </Link>
            <Link to="/company/contact#Book-Meeting" className="button-1">
              Explore Deployment Models
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bioforge;
